import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ex-lib',
  template: `
    <p>
      Hello world
    </p>
  `,
  styles: []
})
export class ExLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
